export const environment = {
  production: false,
  enableSentry: true,
  sentryDsn: 'https://1bf8ea2a131bf14ad8663190fcdb9af1@o511477.ingest.us.sentry.io/4511338491740160',
  enableMixpanel: true,
  mixpanelToken: 'f182b1f2419343eb1b6886ea6d78ba32',
  mixpanelApiHost: 'https://api-js.mixpanel.com',
  name: 'breakfix-qa',
  apiURL: 'https://api-qa-break-fix.nonprod.tonicpos.com/bff/portal/',
  apiURLAuth: 'https://api-qa-break-fix.nonprod.tonicpos.com/bff/auth/portal', 
  version: '1.0',
  pendo: false
};
